import { render } from "./TheDoiTheThao.vue?vue&type=template&id=36ea77db"
import script from "./TheDoiTheThao.vue?vue&type=script&lang=js"
export * from "./TheDoiTheThao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__